<template>
  <div class="flex items-center justify-center flex-shrink-0 mx-auto bg-gradient-to-b bg-gradient from-gray-100 to-[#dce0e6] dark:bg-gradient-to-b dark:bg-gradient dark:from-neutral-900 dark:to-neutral-950 rounded-full w-fit p-4 text-operacolor">
    <slot></slot>
  </div>
</template>

<!-- Works best with size-8 icons -->